import React, { useState } from "react";
import { Grid, Header } from "semantic-ui-react";
import Changelog from "./changelog.json";
import ContentMEP from "components/ContentMEP";
import { useTranslation, Trans } from "react-i18next";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		overflowY: "auto",
		height: "100%",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
};

export const Version = () => {
	const [changelog] = useState(Changelog);
	const { i18n } = useTranslation();
	const getActiveLanguage = () => i18n.language || "fr";
	const lang = getActiveLanguage();

	return (
		<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
			<Grid.Column style={{ maxWidth: 950, padding: 40, height: "93vh" }}>
				<Header as="h2" color="teal" textAlign="center" style={{ backgroundColor: "rgb(0, 147, 128)" }}></Header>
				<div style={styles.blocHeader}>
					<h3>
						<Trans i18nKey="version.title"></Trans>
					</h3>
				</div>
				<div style={styles.blocWhite}>
					{changelog.releases && changelog.releases.length > 0 && (
						<div>
							{changelog.releases.map((item, key) => (
								<ContentMEP key={key} lang={lang} release={item} />
							))}
						</div>
					)}
				</div>
			</Grid.Column>
		</Grid>
	);
};
